<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="dancers">
    <div><h2>Dancers</h2></div>
    <div style="max-width:1000px; width:100%;">
      <v-text-field
        v-model="search"
        dark

        label="Hledat"
        append-icon="mdi-magnify"
        outlined
      />
    </div>
    <div style="max-width:1000px; width:100%;">
      <v-data-table
        v-if="search === ''"
        dark
        :headers="headers"
        :items="dancers"
        :items-per-page="10"
        class="elevation-4"
      >
        <template #item.actions="{ item }">
          <v-icon
            @click="editDancer(item)"
          >
            mdi-magnify
          </v-icon>
          <v-icon
            color="red"
            class="ml-3"
            @click="deleteDancerVerify(item.id)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <v-data-table
        v-else
        dark
        :headers="headers"
        :items="searched"
        :items-per-page="10"
        class="elevation-4"
      >
        <template #item.actions="{ item }">
          <v-icon
            @click="editDancer(item)"
          >
            mdi-magnify
          </v-icon>
          <v-icon
            color="red"
            class="ml-3"
            @click="deleteDancerVerify(item.id)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </div>
    <div
      class="mt-3"
      style="width:100%;max-width:1000px"
    >
      <v-btn
        style="width:100%"
        color="red white--text"
        @click="dialogDeleteAll = true"
      >
        Delete ALL
      </v-btn>
    </div>
    <edit-dancer
      :edit="edit"
      :current-dancer="currentDancer"
      :ws="ws"
      @save="save"
      @close="edit=false"
    />
    <v-dialog
      v-model="dialogDeleteAll"
      max-width="300px"
    >
      <v-card>
        <v-card-title>
          Smazat registraci
        </v-card-title>
        <v-card-text>
          <div v-if="!loading">
            Opravdu si přejete odstranit celou registraci?
          </div>
          <div v-else-if="loading">
            Načítání...
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn

            :disabled="loading"
            text
            @click="dialogDeleteAll = false"
          >
            Zrušit
          </v-btn>
          <v-btn

            :disabled="loading"
            color="red"
            text
            @click="deleteAll()"
          >
            Odstranit
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogDelete"
      max-width="300px"
    >
      <v-card>
        <v-card-title>
          Smazat registraci
        </v-card-title>
        <v-card-text>
          <div v-if="!loading">
            Opravdu si přejete odstranit účastníka?
          </div>
          <div v-else-if="loading">
            Načítání...
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn

            :disabled="loading"
            text
            @click="dialogDelete = false"
          >
            Zrušit
          </v-btn>
          <v-btn

            :disabled="loading"
            color="red"
            text
            @click="deleteDancer()"
          >
            Odstranit
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import db from '@/fb'
import EditDancer from '../../components/dialogs/EditDancer.vue'
export default {
  components: {
    EditDancer
  },
  data () {
    return {
      edit: false,
      dancers: [],
      currentDancer: null,
      dialogDelete: false,
      dialogDeleteAll: false,
      loading: false,
      ws: null,
      search: '',
      id: '',
      headers: [
        {
          text: 'Jméno',
          align: 'start',
          sortable: true,
          value: 'firstName'
        },
        { text: 'Příjmení', value: 'surname', align: 'start' },
        { text: 'Přezdívka', value: 'nickname' },
        { text: 'Email', value: 'email' },
        { text: '7 to smoke', value: 'checkSeven' },
        { text: '2v2', value: 'check2v2' },
        { text: 'Workshop', value: 'checkWorkshop' },
        { text: 'Upravit', value: 'actions', sortable: false }

      ],
      actions: [
        {
          type: 'edit',
          icon: 'mdi-pencil'
        }
      ]

    }
  },
  computed: {
    searched () {
      return this.dancers.filter(dancer => dancer.firstName.toLowerCase().includes(this.search.toLowerCase()) || dancer.surname.toLowerCase().includes(this.search.toLowerCase()) || dancer.nickname.toLowerCase().includes(this.search.toLowerCase()) || dancer.email.toLowerCase().includes(this.search.toLowerCase()))
    }
  },
  created () {
    db.collection('dancers').get().then(res => {
      // eslint-disable-next-line array-callback-return
      res.docs.map(doc => {
        const pes = doc.data()
        pes.id = doc.id
        this.dancers.push(pes)
        console.log(pes)
      }
      )
    })
    db.collection('workshop').get().then(res => {
      // eslint-disable-next-line array-callback-return
      res.docs.map(doc => {
        console.log(doc.data())
        this.ws = doc.data()
      }
      )
    })
  },
  methods: {
    deleteDancerVerify (id) {
      this.dialogDelete = true
      this.id = id
    },
    deleteDancer () {
      this.loading = true
      const currentDancer = this.dancers.filter(dancer => dancer.id === this.id)

      if (currentDancer[0].checkWorkshop === 'Ano') {
        const minus = this.ws.num - 1
        console.log(minus)
        db.collection('workshop')
          .doc('count')
          .update({ num: minus })
      }
      db.collection('dancers').doc(this.id).delete()
        .then(() => {
          this.dialogDelete = false
          this.loading = false
        })
    },
    deleteAll () {
      this.loading = true

      this.dancers.forEach(dancer => {
        const id = dancer.id
        db.collection('dancers').doc(id).delete()
      })
      this.dialogDeleteAll = false
      this.loading = false
    },
    editDancer (dancer) {
      this.edit = true
      this.currentDancer = dancer
      console.log(dancer)
    },
    save (obj) {
      this.edit = false
    }
  }
}
</script>
<style scoped>
.v-main__wrap{

    background: black;
}

.dancers{
    padding-inline: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
margin-bottom: 50px;
    flex-direction: column;
    text-align: center;
    color: #f9d71c;
background-color: black;
}
.dancers h2{
    text-align: center;
    font-family: 'Six Caps', sans-serif;
    font-size: 100px;
    letter-spacing: 1px;
}
.dancers .card{
    padding: 30px;
    width: 100%;
max-width: 1000px;
    border: solid 4px #f9d71c;
    border-radius: 10px;
}
</style>